module.exports = __webpack_public_path__ + "static/media/SVGDatabase.55ab39df.svg";